module.exports = __webpack_public_path__ + "img/hr-red-desert-3.554379c2.png";